/**
 * Auth design tokens — aligned with seller dashboard & listing wizard.
 */
export const authTheme = {
  page: 'min-h-dvh bg-gradient-to-br from-violet-50/90 via-slate-50 to-white',
  card: 'rounded-xl border border-slate-200/80 bg-white p-5 shadow-sm sm:p-6 md:p-8',
  cardMaxWidth: 'max-w-md w-full',
  eyebrow: 'text-[11px] font-semibold uppercase tracking-wider text-purple-600',
  title: 'text-2xl font-semibold text-gray-900',
  subtitle: 'mt-1 text-sm text-gray-500',
  label: 'mb-1 block text-xs font-medium text-gray-700 sm:text-sm',
  field:
    'block w-full rounded-lg border border-gray-300 py-2.5 pl-9 pr-3 text-sm shadow-sm placeholder-gray-400 transition focus:border-transparent focus:outline-none focus:ring-2 focus:ring-purple-500',
  fieldError: 'border-red-300 focus:ring-red-500',
  fieldIcon: 'pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3',
  primaryBtn:
    'inline-flex w-full min-h-[44px] items-center justify-center gap-2 rounded-lg border border-transparent bg-gradient-to-r from-purple-600 to-indigo-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:from-purple-700 hover:to-indigo-700 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-70',
  secondaryBtn:
    'inline-flex min-h-[44px] items-center justify-center rounded-lg border border-slate-200 bg-white px-4 py-2.5 text-sm font-semibold text-gray-700 shadow-sm transition hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2',
  link: 'font-semibold text-purple-600 hover:text-purple-700',
  notice: 'rounded-lg border border-slate-200 bg-slate-50 px-3 py-2.5 text-xs text-slate-700 sm:text-sm',
  noticeAlert: 'rounded-lg border border-amber-200 bg-amber-50 px-3 py-2.5 text-xs text-amber-900 sm:text-sm',
  trust: 'flex items-center gap-2 text-xs text-slate-600 sm:text-sm',
  optionCard:
    'flex w-full items-start gap-3 rounded-xl border px-3 py-3 text-left transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-purple-500 sm:px-4',
  optionCardSelected: 'border-purple-600 bg-purple-50/30 shadow-sm ring-1 ring-purple-600/20',
  optionCardDefault: 'border-gray-200 bg-white hover:border-purple-200 hover:bg-purple-50/20',
} as const;
